import { ChangeEvent } from 'react';
import { DefaultTheme } from 'styled-components';

import { InputProps } from 'src/packages/core';

export type DateRangeValueType = [Date | null, Date | null];
export const DateRangeValuesDelimiter = '→';

export interface DateRangeProps
  extends Omit<
    InputProps,
    'onChange' | 'rightElement' | 'leftElement' | 'passwordConditions' | 'showPasswordHelp'
  > {
  onChange: (date: DateRangeValueType) => void;
  maxDate?: Date | null | undefined;
  minDate?: Date | null | undefined;
  initialStartDate?: Date | null;
  initialEndDate?: Date | null;
  isClearable?: boolean | undefined;
}

export interface CustomInputProps
  extends Omit<DateRangeProps, 'onChange' | 'maxDate' | 'initialStartDate' | 'initialEndDate'> {
  onChange?: (e: ChangeEvent<HTMLInputElement>) => void;
  handleChange: (date: DateRangeValueType) => void;
  defaulttheme: DefaultTheme;
}
